import { render, staticRenderFns } from "./ArchivoAdjuntoCasoEdit.vue?vue&type=template&id=a141afda"
import script from "./ArchivoAdjuntoCasoEdit.vue?vue&type=script&lang=js"
export * from "./ArchivoAdjuntoCasoEdit.vue?vue&type=script&lang=js"
import style0 from "./ArchivoAdjuntoCasoEdit.vue?vue&type=style&index=0&id=a141afda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports